import Papa from "papaparse";
import api from "../../../../services/api";

const downloadUsersResults = async () => {
  const response = await api.get("/admin/users-results", { responseType: "blob" });
  if (response.status === 201 || response.status === 204) {
    throw new Error("קובץ התשובות ריק");
  }
  const csvData = response.data;

  const reader = new FileReader();
  reader.onload = function () {
    Papa.parse(reader.result, {
      header: true,
      complete: function (results) { },
      error: function (error) {
        console.log("error", error);
      },
      download: true
    });
  };
  reader.readAsText(csvData);

  const url = URL.createObjectURL(new Blob([csvData]));
  const link = document.createElement("a");
  link.href = url;
  link.download = "results.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return response;
};

const downloadUsersAttended = async () => {
  const response = await api.get("/admin/users-attended", { responseType: "blob" });
  if (response.status === 201 || response.status === 204) {
    throw new Error("קובץ התשובות ריק");
  }
  const csvData = response.data;

  const reader = new FileReader();
  reader.onload = function () {
    Papa.parse(reader.result, {
      header: true,
      complete: function (results) { },
      error: function (error) {
        console.log("error", error);
      },
      download: true
    });
  };
  reader.readAsText(csvData);

  const url = URL.createObjectURL(new Blob([csvData]));
  const link = document.createElement("a");
  link.href = url;
  link.download = "attended.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return response;
};

const downloadQuestionnaireTests = async () => {
  const response = await api.get("/admin/questionnaire-tests", { responseType: "blob" });
  const zipData = response.data;
  const url = URL.createObjectURL(new Blob([zipData]));
  const link = document.createElement("a");
  link.href = url;
  link.download = "tests.zip";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return response;
};

const downloadFullDB = async () => {
  const response = await api.get("/admin/full-db", { responseType: "blob" });
  const jsonData = response.data;
  const url = URL.createObjectURL(new Blob([jsonData]));
  const link = document.createElement("a");
  link.href = url;
  link.download = "full_db.json";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return response;
};

const getAdminUsers = async () => {
  const response = await api.get("/admin/users");
  return response.data;
};

const downloadUsersAsCsv = async () => {
  const response = await api.get("/admin/users");
  const users = response.data;

  const header = "id,first_name,last_name,gender,questionnaire";
  const rows = users.map(u => {
    const spaceIdx = u.name.indexOf(" ");
    const firstName = spaceIdx === -1 ? u.name : u.name.slice(0, spaceIdx);
    const lastName = spaceIdx === -1 ? "" : u.name.slice(spaceIdx + 1);
    return [u.id, firstName, lastName, u.gender || "-", u.questionnaire || ""].join(",");
  });
  const csv = [header, ...rows].join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = "users.csv";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return response;
};

const downloadCalculatedResults = async () => {
  const response = await api.get("/admin/calculate-results", { responseType: "blob" });
  const zipData = response.data;
  const url = URL.createObjectURL(new Blob([zipData]));
  const link = document.createElement("a");
  link.href = url;
  link.download = "calculated_results.zip";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
  return response;
};

const getPreviewResults = async () => {
  const response = await api.get("/admin/preview-results");
  return response.data;
};

export {
  downloadQuestionnaireTests,
  downloadUsersResults,
  downloadUsersAttended,
  downloadFullDB,
  getAdminUsers,
  downloadUsersAsCsv,
  downloadCalculatedResults,
  getPreviewResults,
};
